import { Observable} from 'rxjs';
 
import { addProvider, IProviderDescriptor } from "../ServiceUtil"; 
import { UserDelegate } from "./user.delegate";

export class UserService
{

    constructor(private userDelegate: UserDelegate)
    {
    }

    public updateDefaultOrgId(userId: string, orgId: string): Observable<boolean>
    {
        return this.userDelegate.updateDefaultOrg(userId, orgId);
    }

}